import React from "react";

import * as R from "ramda";

import { Flex, Text } from "src/components";

import {
  compose,
  componentFromProp,
  withState,
  withProps,
  withHandlers,
} from "recompose";

import enrollmentComponents from "./steps";

import Disclosure from "./Disclosure";

const defaultStateComponent = enrollmentStateKey => () => (
  <Flex>
    <Text>{enrollmentStateKey}</Text>
  </Flex>
);

const enhance = compose(
  withState("enrollmentState", "setEnrollmentStateInternal", {
    key: "entry",
    showDisclosureInterrupt: false,
  }),
  withState("defaultValues", "setDefaultValues"),
  withHandlers({
    setEnrollmentState: ({ setEnrollmentStateInternal }) => state => {
      setEnrollmentStateInternal(state);
      window.scrollTo(0, 0);
    },
  }),
  withProps(({ enrollmentState }) => ({
    component: enrollmentState.showDisclosureInterrupt
      ? Disclosure
      : R.propOr(
          defaultStateComponent(enrollmentState.key),
          enrollmentState.key,
          enrollmentComponents
        ),
  }))
);

const EnrollmentForm = componentFromProp("component");

const Enroll = props => (
  <Flex flexDirection="column" style={{ minHeight: 500 }}>
    <EnrollmentForm {...props} />
  </Flex>
);

export default enhance(Enroll);



// WEBPACK FOOTER //
// ./src/banking/authentication/Enroll/Enroll.js